import { Installation } from 'src/Libs/installations/models'
import { hasAccessToDirectMarketing } from '../../utils'
import { UserData } from '@e3dc-react/shell/Types'

/**
 * Determine if user has access to Inexogy extension
 * @param installation
 * @param userId
 * @returns boolean access
 */
const useInexogyAccess = (installation?: Installation, userData?: UserData): boolean => {
  if (!hasAccessToDirectMarketing(installation, userData)) return false

  return true
}

export default useInexogyAccess
